import s from './Preloader.module.scss';

const Preloader = () => {
  return (
    <div className={s.preloader}/>
  );
};

export default Preloader;
